import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class PostulacionesService
{
    constructor(private http: HttpClient) { }

    sinPostulacionesVigentes(idProducto: any, rut: any, titular: any)
    {
        return this.http.get(`${environment.urlBase}/postulaciones/productos/${idProducto}/rut/${rut}/titular/${titular}`,
               { headers: this.armaCabecera() } ).toPromise();
    }

    traeRegiones()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/regiones`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeEstados()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/estados`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeEstadosSubsidios()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/estadosSubsidios`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeTipoProductoSubsidios(idEjecutivo: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/tipoProductos/idUsuario/${idEjecutivo}`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeUsuario(rut: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/afiliados/rut/${rut}`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeDocumento(documento: any)
    {
        return this.http.get(`${environment.urlApiAyudaMedica}/ayudamedica/documento/${documento}`,
        { headers:this.armaCabecera() }).toPromise();
    }


    cambiarEstadoPostulacion(idPostulacion: any, estado: any,idUsuarioSesion: any)
    {
        return this.http.post(`${environment.urlApiOperacion}/solicitudes/`,
               { id: idPostulacion, estado: estado,idUsuarioSesion:idUsuarioSesion }, { headers:this.armaCabecera() } ).toPromise();
    }

    rechazarPostulacion(idPostulacion: any, idMotivoRechazo: any, motivoRechazo: any, comentarioRechazo: any,  idUsuarioSesion: any)
    {
        return  this.http.post(`${environment.urlApiOperacion}/solicitudes/`,
        {
            id: idPostulacion,
            estado: 'RECHAZADA',
            idMotivoRechazo: idMotivoRechazo,
            comentarioMotRechazo: comentarioRechazo,
            motivo: motivoRechazo,
            idUsuarioSesion:idUsuarioSesion
        },
        { headers:this.armaCabecera() } ).toPromise()
    }

    traePostulacionesDisponibles(email: any, buscador?: any)

    {
        return this.http.post(`${environment.urlApiSolicitudes}/postulaciones/beca-y-escolaridad/ejecutivo/email`,
        {
            email: email,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            filtroIngresado: false,
            numeroPagina:buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idRegion:buscador?.region,
            rut: buscador?.rut,
            idSolicitud: buscador?.idSolicitud,
            estado: buscador?.estado,
            tipoProducto: buscador?.tipoProductoselect
        },
        { headers:this.armaCabecera() }).toPromise()
    }

    traePostulacionesAsignadas(idEjecutivo: any, buscador?: any)
    {
        return this.http.post(`${environment.urlApiSolicitudes}/postulaciones/beca-y-escolaridad/ejecutivos/id`,
        {
            id:idEjecutivo,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idSolicitud: buscador?.idSolicitud,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            rut: buscador?.rut,
            estado: buscador?.estado,
            tipoProducto: buscador?.tipoProductoselect
        },
        { headers:this.armaCabecera() }).toPromise()
    }

    asignaPostulacion(postulaciones: any, idEjecutivo: any)
    {
        console.log(postulaciones)
        return this.http.post(`${environment.urlApiOperacion}/solicitudes/asignar/ejecutivo/${idEjecutivo}`,
        postulaciones, { headers:this.armaCabecera() } ).toPromise()
    }

    traePostulacionBeca(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/becas/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traePostulacionEscolaridad(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/escolaridad/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traePostulacionNacimiento(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSubsidio}/postulaciones/${idPostulacion}/nacimiento/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traePostulacionMatrimonio(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSubsidio}/postulaciones/${idPostulacion}/matrimonio/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traePostulacionCatastrofe(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSubsidio}/postulaciones/${idPostulacion}/catastrofe/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traePostulacionFallecimiento(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSubsidio}/postulaciones/${idPostulacion}/fallecimiento/`,
               { headers:this.armaCabecera() }).toPromise()
    }
    

    editaPostulacionBeca(idPostulacion: any, idCarga: any, nota: any, idCurso: any,idUsuario:any, idUsuarioSesion:any,diagnosticoEspecial:any)
    {
        return this.http.put(`${environment.urlApiOperacion}/solicitudes/`,
        {
            id: idPostulacion,
            idCarga: idCarga,
            idUsuarioSesion : idUsuarioSesion,
            idUsuario: idUsuario,
            idProducto: 1,
            beca: { calificacion:nota, idCurso:idCurso,diagnosticoEspecial:diagnosticoEspecial }
        },
        { headers:this.armaCabecera() } ).toPromise()
    }

    editaPostulacionEscolaridad(idPostulacion: any, idCarga: any, fechaCertificado: any, etapa: any,idUsuario:any,idUsuarioSesion:any )
    {
      if(idCarga!=null){
        idCarga=idCarga.id;
      }else{
        idUsuario=idUsuario.id;
      }

        return this.http.put(`${environment.urlApiOperacion}/solicitudes/`,
        {
            id: idPostulacion,
            idCarga: idCarga,
            idUsuario: idUsuario,
            idUsuarioSesion:idUsuarioSesion,
            idProducto: 2,
            escolaridad: { fechaCertificado:fechaCertificado, etapa:etapa }
        },
        { headers:this.armaCabecera() } ).toPromise()
    }

    motivoRechazo(idProducto: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/motivoRechazo/productos/${idProducto}/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traeArchivos(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/archivo-adjunto/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}
